module.exports = {"340406001":"田集街道","340406100":"高皇镇","340406101":"平圩镇","340406102":"泥河镇","340406103":"潘集镇","340406104":"芦集镇","340406105":"架河镇","340406106":"夹沟镇","340406107":"祁集镇","340406108":"贺疃镇","340406202":"古沟回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340406.json
// module id = 1177
// module chunks = 0